class ContactPanel extends Panel {
  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    // super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    if (previousState === 'idle') {
      actions.openRightFullNav().then(() => {
        window.trapFocus(this, this.defaultFocus, triggerElement);
      });
    } else if (previousPanel) {
      previousPanel.deactivate();
    }
    if (window.GorgiasChat && window.GorgiasChat.isChatOnline()) {
      this.classList.add('chat-active');
    } else {
      this.classList.remove('chat-active');
    }
  }
}
customElements.define('contact-panel', ContactPanel);
